<div id="establishment-details-activities-card" class="card mt-6">
  <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title m-0">
      {{ entityName }}
      <icon-warning
        class="ml-2"
        [show]="displayPostePercentWarning"
        [toolTip]="'Le pourcentage doit être égal à 100%'"
      ></icon-warning>
    </h2>
  </div>

  <div class="card overflow-hidden shadow-0 p-3">
    <nav class="vex-tabs vex-tabs-dense border-0 pt-2 shadow-0" mat-tab-nav-bar>
      <div *ngFor="let link of defaultTabs" class="flex items-center gap-1">
        <a
          #rla="routerLinkActive"
          [active]="rla.isActive"
          [routerLink]="link.route"
          mat-tab-link
          queryParamsHandling="preserve"
          [routerLinkActiveOptions]="link.routerLinkActiveOptions || { exact: false }"
          routerLinkActive
        >
          {{ link.label }}
        </a>
        <button
          mat-mini-fab
          class="ml-2 !w-8 !h-8 flex items-center justify-center"
          style="box-shadow: none"
          color="primary"
          [matTooltip]="getTitleTip(link.label)"
          [permissionBlock]="[ENUM_PERMISSIONS.UPDATE_ESTABLISHMENT]"
          (click)="addGenerics(link.label)"
          type="button"
        >
          <mat-icon [icIcon]="icAdd"></mat-icon>
        </button>
      </div>
    </nav>
  </div>
  <router-outlet></router-outlet>
</div>
